// This must always be first
import "./require";

// Third-party dependencies
import "popper.js";
import "bootstrap";
import "lazysizes";
import "lazysizes/plugins/object-fit/ls.object-fit.js";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "lazysizes/plugins/respimg/ls.respimg.js";
import "fluidbox";
import "smartmenus";
import "smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js";




// import "bs-offcanvas";

// Theme scripts
import { AdvancedForm } from "./advanced-forms";
import { iframeResize, loadInFrame } from "./ajax-iframe";
import { getScrollbarWidth } from "./css-vars";
import { better_wpcf7_forms } from "./forms";
import { ajax_search } from "./search";
import { woocommerceFeatures } from "./woocommerce";
import { shareButtons } from "./share-buttons";
import { Offcanvas } from "bootstrap";

document.addEventListener("DOMContentLoaded", () => {
  /**
   * Document on ready we will load the OffCanvasNiche function.
   */
  offCanvasNiche();
  /**
   * We must also await new content loaded from facet!
   */
  document.addEventListener('facetwp-loaded', () => {
    offCanvasNiche();
  });
});

function offCanvasNiche() {
  document.querySelectorAll('[data-href]').forEach((e: HTMLElement) => {
    /**
     * if the content was loaded previously return early.
     */
    if (e.getAttribute('data-loaded') === 'true') return;

    /**
     * We get both the "data-url" and the "real-url" for refrence once.
     */
    let url = e.getAttribute('data-href'); //#offcanvas82
    let realLink = e.getAttribute('href'); //https://
    /**
     * We get the current location. as this can change depending on what page the canvas in on
     * explained later why we cant use a back command.
     */
    let currentLocation = window.location.href;
    if (!url || !realLink) return;
    /** set data-loaded to true so we do not re fire this code twice */
    e.setAttribute('data-loaded', 'true');
    e.addEventListener('click', function (i) {
      i.preventDefault();
      /**
       * We pass in the real "href" as a push state.
       */
      window.history.pushState({}, "", realLink);
      /**
       * Find the element refrenced as the offcanvas
       */
      let elem = document.querySelector(url);
      if (!elem) return;
      let oc = new Offcanvas(document.querySelector(url));
      elem.addEventListener('hidden.bs.offcanvas', function () {
        /**
         * We are not going back in history as this would require i rewrite to push state.
         * asking for window.history.back() would reload the page.
         */
        window.history.pushState({}, "", currentLocation);
      });
      /**
       * Show the canvas
       */
      oc.show();
    });
  });
}



const $ = jQuery;

$(() => {

  $('form.af-form').each(function (this: HTMLFormElement) {
    new AdvancedForm(this);
  });

  document.documentElement.style.setProperty('--scrollbar-width', getScrollbarWidth() + 'px');

  ajax_search();
  woocommerceFeatures();
  loadInFrame(); // loads content into iframe
  iframeResize(); // Automatically resizes iframes
  shareButtons();

  better_wpcf7_forms();
  $('.gallery a.thumbnail').fluidbox();
  $('.gallery a.thumbnail img').each(function (this: HTMLImageElement) {
    if (this.src !== this.getAttribute('src')) {
      $(this).replaceWith($(this.outerHTML));
    }
  });

  // flyout menu
  $('.navbar-collapse.width').on('show.bs.collapse hide.bs.collapse', function (e) {
    $('body').toggleClass('menu-visible');
  });

  // Colour membership product name
  $('#membership-tabs .fl-tabs-label').each(function () {
    var t = $(this).text().split(' ');
    $(this).html('<span>' + t[0] + '</span> ' + t[1]);
  });

  $('.navbar-toggler').on('click', function () {
    $('#main-menu').not('.show').closest('.navbar').addClass('scroll');
  });

  $('#field_7_contains').attr('placeholder', 'Search by Sport or role...');
  $('#field_any_contains').attr('placeholder', 'Search...');
  $('#field_any_contains').attr('placeholder', 'Search...');
  $("#form_433 .submit").val("Submit");
  $(document).ready(function () {
    $('.gmrbw-variation').each(function () {
      $(this).find('.gmrbw-variation-name').text(function (i, oldText) {
        let text = $(this).text();
        let newText = text.split('–');
        return newText[1];
      });
    });
  });

  $(window).on('resize scroll', function (e) {
    if ($(window).scrollTop() > $('.page-header .fixed-top').height() && !$('.page-header .fixed-top').is('.scroll')) {
      $('.page-header .fixed-top').addClass('scroll');
    } else if ($(window).scrollTop() < $('.page-header .fixed-top').height() && $('.page-header .fixed-top').is('.scroll')) {
      $('.page-header .fixed-top').removeClass('scroll');
    }
  });

  $("#add-to-cart-link").on("click", function () {
    $('html, body').animate({
      'scrollTop': $('#add-to-cart-form').offset().top - 200
    }, 1000);
  });

});

// hard fix to show dropdown menu
const MobileMenuToggle = document.querySelector(".navbar-toggler");
const MobileNavbar = document.querySelector(".navbar");
const MainMenu = document.querySelector("#main-menu");

MobileMenuToggle?.addEventListener('click', () => {
  MainMenu?.classList.toggle('show');
  if (MainMenu?.classList.contains('show')) {
    MobileNavbar?.classList.add('show');
  } else {
    MobileNavbar?.classList.remove('show');
  }
})
